// extracted by mini-css-extract-plugin
module.exports = {"toggle":"toggle-1juFN","loyalty_switch_open":"loyalty_switch_open-3-ctt","switch__label":"switch__label-2UHPl","loyalty__desc":"loyalty__desc-MGKY7"};